export default __webpack_public_path__ + "static/media/sequelize.d98b2554.png";